import { render, staticRenderFns } from "./InvoicingAdmin.vue?vue&type=template&id=324966b7"
import script from "./InvoicingAdmin.vue?vue&type=script&lang=js"
export * from "./InvoicingAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports